window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {

      console.log('_onSelectChange');

      var variant = this._getVariantFromOptions();

      console.log('variant');
      console.log(variant);

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */
var zoomImages = function() {
  $('.js-productZoom').each(function(){
      var parent = $(this).parent();
      $(parent).trigger('zoom.destroy');

        if( $(window).innerWidth() > 1024 ){
        $(parent)
        .zoom({
            url: $(parent).attr('data-zoom'),
            touch: false,
            duration: 200,
            onZoomIn: function(){
                $(this).parent().find('.zoomImg').addClass('zoom-in');
            },
            onZoomOut: function(){
                $(this).parent().find('.zoomImg').removeClass('zoom-in');
            },
            callback: function(){
                $(this).parent().on('touchstart tap touchmove',function(){
                  $(this).trigger('zoom.destroy');
                })
            }
        });
      }
  });
}
$(document).ready(function() {
    zoomImages();
});

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    productAfterpay: '.afterpay-paragraph',
    // singleOptionSelector: '[action="/cart/add"] [data-single-option-selector]'
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    console.log('container')
    console.log(this.$container)

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    // this.$container.on('variantImageChange' + this.namespace, this._switchGallery.bind(this));
    // this.SelectedOptions(this.productSingleObject);

    // var self = this;

    // $(selectors.singleOptionSelector, this.$container).on('change',function(){
    //     self.updateOptions( $(this), productSingleObject)
    // })

    this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }

    /*
     *  Customization to update and add product price and product up sell
     *  sum total to update the price displayed to the customer.
    */
    var prodvariants = this.variants;

    $(document).on('click', '.bold_option input', function() {
      var currentVariantPrice = prodvariants.currentVariant.price;
      var updatedPriceFormatted;
      var updatedPrice;

      // Using a timeout to wait for Bold event to occur and show the up sell price selected
      setTimeout(function(){
        var upsellPrice = $('.bold_option_price_display').text().split('$')[1];
        if (upsellPrice == undefined) {
          $(selectors.productPrice, this.$container).html(slate.Currency.formatMoney(currentVariantPrice, theme.moneyFormat));
        } else {
          var upsellPriceInCents = upsellPrice * 100;
          updatedPrice = currentVariantPrice + upsellPriceInCents;
          updatedPriceFormatted = slate.Currency.formatMoney(updatedPrice, theme.moneyFormat);
          $(selectors.productPrice, this.$container).html(slate.Currency.formatMoney(updatedPrice, theme.moneyFormat));
        }
      }, 750);
    });

    $(document).on('change', '.bold_option select', function() {
      var currentVariantPrice = prodvariants.currentVariant.price;
      var updatedPriceFormatted;
      var updatedPrice;

      // Using a timeout to wait for Bold event to occur and show the up sell price selected
      setTimeout(function(){
        var upsellPrice = $('.bold_option_price_display').text().split('$')[1];
        if (upsellPrice == undefined) {
          $(selectors.productPrice, this.$container).html(slate.Currency.formatMoney(currentVariantPrice, theme.moneyFormat));
        } else {
          var upsellPriceInCents = upsellPrice * 100;
          updatedPrice = currentVariantPrice + upsellPriceInCents;
          updatedPriceFormatted = slate.Currency.formatMoney(updatedPrice, theme.moneyFormat);
          $(selectors.productPrice, this.$container).html(slate.Currency.formatMoney(updatedPrice, theme.moneyFormat));
        }
        }, 750);
    });


    /* --------------------------------
        Product Bold Options
    -------------------------------- */
    /*
    *   BUNDLE PRODUCTS
    */
    if (typeof isBundleProduct != 'undefined') {
        if (!isBundleProduct) {return}
        console.log('BUDLE JS');
        function clearCart() {
          jQuery.post('/cart/clear.js');
        }

        var optionsIds = '';
        var optionsSkus = '';

        $('[data-add-to-cart]').on('click', function(e) {
          e.preventDefault();
          var selectedQty = $('[name="quantity"]').val();
          var optionsSelected = $('[data-bundle-product-select]').each(function(index, element) {
            var optionId = $(element).val();
            if (index > 0) {
              optionsSkus += ',' + $('[data-bundle-product-select]').find('[value="' + optionId + '"]').data('sku');
            } else {
              optionsSkus += $('[data-bundle-product-select]').find('[value="' + optionId + '"]').data('sku');
            }
          });

          var mainProductSelected = $('[data-product-select]').val();





          var bundleVariantSku = $('[data-product-select]').find('[value="' + mainProductSelected + '"]').data('bundle-variant-sku');


          var skus = '';

          if (optionsSkus != undefined) {
            skus += optionsSkus
          }

          if (bundleVariantSku) {
            if (skus != '') {
              skus += ',';
            }
            skus += bundleVariantSku;
          }


          var productProps = {'Bundle SKUS': skus};

          var boldOptionsInputValues = [];

          var regex = /(?=\[).+?(?=\])/g;

          $('.bold_option_element input').each(function(index, el) {
            var inputValue = $(el).val();
            var inputName = $(el).attr('name');


            console.log($(el));


            if (inputValue != '' && inputValue != undefined && inputName != undefined && inputName != '') {

              console.log('inputValue');
              console.log(inputValue);

              console.log('inputName');
              console.log(inputName);
              console.log(typeof(inputName));

              // console.log( inputName.replace(']','').split('properties[') );
              // console.log( inputName.replace(']','').split('properties[')[0] );
              console.log( inputName.replace(']','').split('properties[')[1] );
              var propertyName = inputName.replace(']','').split('properties[')[1];


              // var propertyName = inputName.match(regex);
              // var propertyName = JSON.stringify(propertyName);




              console.log('propertyName');
              console.log(propertyName);
              console.log(typeof(propertyName));

              console.log( JSON.stringify(inputName) );
              console.log(propertyName.split('[')[0]);


              productProps[propertyName] = inputValue;
              // productProps = {propertyName: inputValue};

              console.log('productProps');
              console.log(productProps);
            }

          });

          console.log('boldOptionsInputValues');
          console.log(boldOptionsInputValues);

    /*
          if (options.boldAppOptionBabyName != '') {
            productProps['Baby\'s Name'] = options.boldAppOptionBabyName;
          }

          if (options.boldAppOptionBigKidsName != '') {
            productProps['Big Kid\'s Name'] = options.boldAppOptionBigKidsName;
          }

          if (options.boldAppOptionBirthMonth != '') {
            productProps['Birth Month'] = options.boldAppOptionBirthMonth;
          }

          if (options.boldAppOptionAddFreeCustomization != '') {
            productProps['Add Customization (FREE)'] = '✓';
          }
    */


          console.log('productProps');
          console.log(productProps);






          var bundleOptions = {
            productId: $('[data-product-select]').val(),
            optionId: optionsSelected,
            optionSku: $('[data-bundle-product-select]').find('[value="' + optionsSelected + '"]').data('sku'),
            optionsSkus: optionsSkus,
            optionTitle: $('[data-bundle-product-select]').find('[value="' + optionsSelected + '"]').data('variant-title'),
            productTitle: $('[data-bundle-product-select]').find('[value="' + optionsSelected + '"]').data('product-title'),
            qty: selectedQty,
            bundleVariantSku: $('[data-product-select]').find('[value="' + mainProductSelected + '"]').data('bundle-variant-sku'),


            // boldAppOptionBabyName: $('[name="properties[Baby\'s Name]"]').val(),
            // boldAppOptionAddFreeCustomization: $('[name="properties[Add Customization (FREE)]"]').val(),
            // boldAppOptionBigKidsName: $('[name="properties[Big Kid\'s Name]"]').val(),
            // boldAppOptionBirthMonth: $('[name="properties[Birth Month]"]').val()


            boldOptionsInputValues: boldOptionsInputValues,
            productProps: productProps
          };

          addBundleToCart(bundleOptions);
        });

        function addBundleToCart(options) {

          console.log({
            quantity: options.qty,
            id: options.productId,
            properties: options.productProps
          });

          // jQuery.post('/cart/add.js', {
          //   quantity: options.qty,
          //   id: options.productId,
          //   properties: options.productProps
          // }).done(function() {
          //   // window.location = '/cart';
          // });



          jQuery.ajax({
            url:'/cart/add.js',
            type: 'post',
            dataType: 'json',
            data: {
              quantity: options.qty,
              id: options.productId,
              properties: options.productProps
            }
            // Optional: success/error functions
          }).done(function() {
            // console.log('success!!!');
            window.location = '/cart';
          });


        /*
        var boldOptions = jQuery('.bold_option_total').children().serialize();

        jQuery.ajax({
          url:'/cart/add.js',
          type: 'post',
          data: boldOptions
          ,contentType: 'application/json'
        }).done(function() {
          console.log('BOLD success!!!');
        });
        */


        }
    }
    // -------------------------------------------------------------------------
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('price-unavailable');
        $(selectors.productAfterpay, this.$container).removeClass('afterpay-unavailable');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('price-unavailable');
        $(selectors.productAfterpay, this.$container).addClass('afterpay-unavailable');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      var upsellPrice = $('.bold_option_price_display').text().split('$')[1];
      var upsellPriceInCents = upsellPrice * 100;
      var variantPrice = variant.price;
      var combindedPrice = variantPrice + upsellPriceInCents;


      if (upsellPrice == undefined) {
        $(selectors.productPrice, this.$container)
          .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));
      } else {
        $(selectors.productPrice, this.$container)
          .html(slate.Currency.formatMoney(combindedPrice, theme.moneyFormat));
      }

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('price-unavailable');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('price-unavailable');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      // var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);
      var galleryImg = variant.featured_image.src.split('products/')[1].split('?')[0];
      var galleryImgIndex = $('.image-gallery__main [data-img-src="products/' + galleryImg + '"]').index();
      $('.js-slickSlideProdThumbs').slick('slickGoTo', galleryImgIndex);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });
  $(".stamped-sort-select-wrapper").append("<span class='sort-btn'>Sort BY: </span>");
  $(".stamped-review-header .author").after('<p class="verfied">Verified Buyer</p>');
  $("#tab-reviews").click(function(){
    $(".sort-btn").show();
  });
  $("#tab-questions").click(function(){
  $(".sort-btn").hide();
  if( $(".stamped-review-header-byline p").hasClass("verfied")){}
  else{

  $(".stamped-review-header-byline .author").after('<p class="verfied">Verified Buyer</p>');
  $(".stamped-review-header .stamped-review-header-byline .created").hide();
}
  });
  var filter_div = $(".stamped-reviews-filter").html();
  $(".stamped-tabs").after(filter_div);
  return Product;


})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
  $(".add-address-btn").click(function(){
    $(".saved-addresses__container").addClass("hide");
  });
  $(".cancel-btn").click(function(){
    $(".saved-addresses__container").removeClass("hide");
  });
  $(".address-edit-toggle").click(function(){
    $(".edit-address__container").removeClass("hide");
    $(".saved-addresses__container").addClass("hide");
  });
  $(".cancel-btn-edit").click(function(){
    $(".edit-address__container").addClass("hide");
    $(".saved-addresses__container").removeClass("hide");
  });
  $(".add-mobile").click(function(){
    $(this).hide();
    $(".saved-addresses__container").addClass("hide");
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


/*================ Vendor ================*/
/*!
jQuery Validation Plugin - v1.17.0 - 7/29/2017
* https://jqueryvalidation.org/
* Copyright (c) 2017 J�rn Zaefferer; Licensed MIT */
!function(a){"function"==typeof define&&define.amd?define(["jquery"],a):"object"==typeof module&&module.exports?module.exports=a(require("jquery")):a(jQuery)}(function(a){a.extend(a.fn,{validate:function(b){if(!this.length)return void(b&&b.debug&&window.console&&console.warn("Nothing selected, can't validate, returning nothing."));var c=a.data(this[0],"validator");return c?c:(this.attr("novalidate","novalidate"),c=new a.validator(b,this[0]),a.data(this[0],"validator",c),c.settings.onsubmit&&(this.on("click.validate",":submit",function(b){c.submitButton=b.currentTarget,a(this).hasClass("cancel")&&(c.cancelSubmit=!0),void 0!==a(this).attr("formnovalidate")&&(c.cancelSubmit=!0)}),this.on("submit.validate",function(b){function d(){var d,e;return c.submitButton&&(c.settings.submitHandler||c.formSubmitted)&&(d=a("<input type='hidden'/>").attr("name",c.submitButton.name).val(a(c.submitButton).val()).appendTo(c.currentForm)),!c.settings.submitHandler||(e=c.settings.submitHandler.call(c,c.currentForm,b),d&&d.remove(),void 0!==e&&e)}return c.settings.debug&&b.preventDefault(),c.cancelSubmit?(c.cancelSubmit=!1,d()):c.form()?c.pendingRequest?(c.formSubmitted=!0,!1):d():(c.focusInvalid(),!1)})),c)},valid:function(){var b,c,d;return a(this[0]).is("form")?b=this.validate().form():(d=[],b=!0,c=a(this[0].form).validate(),this.each(function(){b=c.element(this)&&b,b||(d=d.concat(c.errorList))}),c.errorList=d),b},rules:function(b,c){var d,e,f,g,h,i,j=this[0];if(null!=j&&(!j.form&&j.hasAttribute("contenteditable")&&(j.form=this.closest("form")[0],j.name=this.attr("name")),null!=j.form)){if(b)switch(d=a.data(j.form,"validator").settings,e=d.rules,f=a.validator.staticRules(j),b){case"add":a.extend(f,a.validator.normalizeRule(c)),delete f.messages,e[j.name]=f,c.messages&&(d.messages[j.name]=a.extend(d.messages[j.name],c.messages));break;case"remove":return c?(i={},a.each(c.split(/\s/),function(a,b){i[b]=f[b],delete f[b]}),i):(delete e[j.name],f)}return g=a.validator.normalizeRules(a.extend({},a.validator.classRules(j),a.validator.attributeRules(j),a.validator.dataRules(j),a.validator.staticRules(j)),j),g.required&&(h=g.required,delete g.required,g=a.extend({required:h},g)),g.remote&&(h=g.remote,delete g.remote,g=a.extend(g,{remote:h})),g}}}),a.extend(a.expr.pseudos||a.expr[":"],{blank:function(b){return!a.trim(""+a(b).val())},filled:function(b){var c=a(b).val();return null!==c&&!!a.trim(""+c)},unchecked:function(b){return!a(b).prop("checked")}}),a.validator=function(b,c){this.settings=a.extend(!0,{},a.validator.defaults,b),this.currentForm=c,this.init()},a.validator.format=function(b,c){return 1===arguments.length?function(){var c=a.makeArray(arguments);return c.unshift(b),a.validator.format.apply(this,c)}:void 0===c?b:(arguments.length>2&&c.constructor!==Array&&(c=a.makeArray(arguments).slice(1)),c.constructor!==Array&&(c=[c]),a.each(c,function(a,c){b=b.replace(new RegExp("\\{"+a+"\\}","g"),function(){return c})}),b)},a.extend(a.validator,{defaults:{messages:{},groups:{},rules:{},errorClass:"error",pendingClass:"pending",validClass:"valid",errorElement:"label",focusCleanup:!1,focusInvalid:!0,errorContainer:a([]),errorLabelContainer:a([]),onsubmit:!0,ignore:":hidden",ignoreTitle:!1,onfocusin:function(a){this.lastActive=a,this.settings.focusCleanup&&(this.settings.unhighlight&&this.settings.unhighlight.call(this,a,this.settings.errorClass,this.settings.validClass),this.hideThese(this.errorsFor(a)))},onfocusout:function(a){this.checkable(a)||!(a.name in this.submitted)&&this.optional(a)||this.element(a)},onkeyup:function(b,c){var d=[16,17,18,20,35,36,37,38,39,40,45,144,225];9===c.which&&""===this.elementValue(b)||a.inArray(c.keyCode,d)!==-1||(b.name in this.submitted||b.name in this.invalid)&&this.element(b)},onclick:function(a){a.name in this.submitted?this.element(a):a.parentNode.name in this.submitted&&this.element(a.parentNode)},highlight:function(b,c,d){"radio"===b.type?this.findByName(b.name).addClass(c).removeClass(d):a(b).addClass(c).removeClass(d)},unhighlight:function(b,c,d){"radio"===b.type?this.findByName(b.name).removeClass(c).addClass(d):a(b).removeClass(c).addClass(d)}},setDefaults:function(b){a.extend(a.validator.defaults,b)},messages:{required:"This field is required.",remote:"Please fix this field.",email:"Please enter a valid email address.",url:"Please enter a valid URL.",date:"Please enter a valid date.",dateISO:"Please enter a valid date (ISO).",number:"Please enter a valid number.",digits:"Please enter only digits.",equalTo:"Please enter the same value again.",maxlength:a.validator.format("Please enter no more than {0} characters."),minlength:a.validator.format("Please enter at least {0} characters."),rangelength:a.validator.format("Please enter a value between {0} and {1} characters long."),range:a.validator.format("Please enter a value between {0} and {1}."),max:a.validator.format("Please enter a value less than or equal to {0}."),min:a.validator.format("Please enter a value greater than or equal to {0}."),step:a.validator.format("Please enter a multiple of {0}.")},autoCreateRanges:!1,prototype:{init:function(){function b(b){!this.form&&this.hasAttribute("contenteditable")&&(this.form=a(this).closest("form")[0],this.name=a(this).attr("name"));var c=a.data(this.form,"validator"),d="on"+b.type.replace(/^validate/,""),e=c.settings;e[d]&&!a(this).is(e.ignore)&&e[d].call(c,this,b)}this.labelContainer=a(this.settings.errorLabelContainer),this.errorContext=this.labelContainer.length&&this.labelContainer||a(this.currentForm),this.containers=a(this.settings.errorContainer).add(this.settings.errorLabelContainer),this.submitted={},this.valueCache={},this.pendingRequest=0,this.pending={},this.invalid={},this.reset();var c,d=this.groups={};a.each(this.settings.groups,function(b,c){"string"==typeof c&&(c=c.split(/\s/)),a.each(c,function(a,c){d[c]=b})}),c=this.settings.rules,a.each(c,function(b,d){c[b]=a.validator.normalizeRule(d)}),a(this.currentForm).on("focusin.validate focusout.validate keyup.validate",":text, [type='password'], [type='file'], select, textarea, [type='number'], [type='search'], [type='tel'], [type='url'], [type='email'], [type='datetime'], [type='date'], [type='month'], [type='week'], [type='time'], [type='datetime-local'], [type='range'], [type='color'], [type='radio'], [type='checkbox'], [contenteditable], [type='button']",b).on("click.validate","select, option, [type='radio'], [type='checkbox']",b),this.settings.invalidHandler&&a(this.currentForm).on("invalid-form.validate",this.settings.invalidHandler)},form:function(){return this.checkForm(),a.extend(this.submitted,this.errorMap),this.invalid=a.extend({},this.errorMap),this.valid()||a(this.currentForm).triggerHandler("invalid-form",[this]),this.showErrors(),this.valid()},checkForm:function(){this.prepareForm();for(var a=0,b=this.currentElements=this.elements();b[a];a++)this.check(b[a]);return this.valid()},element:function(b){var c,d,e=this.clean(b),f=this.validationTargetFor(e),g=this,h=!0;return void 0===f?delete this.invalid[e.name]:(this.prepareElement(f),this.currentElements=a(f),d=this.groups[f.name],d&&a.each(this.groups,function(a,b){b===d&&a!==f.name&&(e=g.validationTargetFor(g.clean(g.findByName(a))),e&&e.name in g.invalid&&(g.currentElements.push(e),h=g.check(e)&&h))}),c=this.check(f)!==!1,h=h&&c,c?this.invalid[f.name]=!1:this.invalid[f.name]=!0,this.numberOfInvalids()||(this.toHide=this.toHide.add(this.containers)),this.showErrors(),a(b).attr("aria-invalid",!c)),h},showErrors:function(b){if(b){var c=this;a.extend(this.errorMap,b),this.errorList=a.map(this.errorMap,function(a,b){return{message:a,element:c.findByName(b)[0]}}),this.successList=a.grep(this.successList,function(a){return!(a.name in b)})}this.settings.showErrors?this.settings.showErrors.call(this,this.errorMap,this.errorList):this.defaultShowErrors()},resetForm:function(){a.fn.resetForm&&a(this.currentForm).resetForm(),this.invalid={},this.submitted={},this.prepareForm(),this.hideErrors();var b=this.elements().removeData("previousValue").removeAttr("aria-invalid");this.resetElements(b)},resetElements:function(a){var b;if(this.settings.unhighlight)for(b=0;a[b];b++)this.settings.unhighlight.call(this,a[b],this.settings.errorClass,""),this.findByName(a[b].name).removeClass(this.settings.validClass);else a.removeClass(this.settings.errorClass).removeClass(this.settings.validClass)},numberOfInvalids:function(){return this.objectLength(this.invalid)},objectLength:function(a){var b,c=0;for(b in a)void 0!==a[b]&&null!==a[b]&&a[b]!==!1&&c++;return c},hideErrors:function(){this.hideThese(this.toHide)},hideThese:function(a){a.not(this.containers).text(""),this.addWrapper(a).hide()},valid:function(){return 0===this.size()},size:function(){return this.errorList.length},focusInvalid:function(){if(this.settings.focusInvalid)try{a(this.findLastActive()||this.errorList.length&&this.errorList[0].element||[]).filter(":visible").focus().trigger("focusin")}catch(b){}},findLastActive:function(){var b=this.lastActive;return b&&1===a.grep(this.errorList,function(a){return a.element.name===b.name}).length&&b},elements:function(){var b=this,c={};return a(this.currentForm).find("input, select, textarea, [contenteditable]").not(":submit, :reset, :image, :disabled").not(this.settings.ignore).filter(function(){var d=this.name||a(this).attr("name");return!d&&b.settings.debug&&window.console&&console.error("%o has no name assigned",this),this.hasAttribute("contenteditable")&&(this.form=a(this).closest("form")[0],this.name=d),!(d in c||!b.objectLength(a(this).rules()))&&(c[d]=!0,!0)})},clean:function(b){return a(b)[0]},errors:function(){var b=this.settings.errorClass.split(" ").join(".");return a(this.settings.errorElement+"."+b,this.errorContext)},resetInternals:function(){this.successList=[],this.errorList=[],this.errorMap={},this.toShow=a([]),this.toHide=a([])},reset:function(){this.resetInternals(),this.currentElements=a([])},prepareForm:function(){this.reset(),this.toHide=this.errors().add(this.containers)},prepareElement:function(a){this.reset(),this.toHide=this.errorsFor(a)},elementValue:function(b){var c,d,e=a(b),f=b.type;return"radio"===f||"checkbox"===f?this.findByName(b.name).filter(":checked").val():"number"===f&&"undefined"!=typeof b.validity?b.validity.badInput?"NaN":e.val():(c=b.hasAttribute("contenteditable")?e.text():e.val(),"file"===f?"C:\\fakepath\\"===c.substr(0,12)?c.substr(12):(d=c.lastIndexOf("/"),d>=0?c.substr(d+1):(d=c.lastIndexOf("\\"),d>=0?c.substr(d+1):c)):"string"==typeof c?c.replace(/\r/g,""):c)},check:function(b){b=this.validationTargetFor(this.clean(b));var c,d,e,f,g=a(b).rules(),h=a.map(g,function(a,b){return b}).length,i=!1,j=this.elementValue(b);if("function"==typeof g.normalizer?f=g.normalizer:"function"==typeof this.settings.normalizer&&(f=this.settings.normalizer),f){if(j=f.call(b,j),"string"!=typeof j)throw new TypeError("The normalizer should return a string value.");delete g.normalizer}for(d in g){e={method:d,parameters:g[d]};try{if(c=a.validator.methods[d].call(this,j,b,e.parameters),"dependency-mismatch"===c&&1===h){i=!0;continue}if(i=!1,"pending"===c)return void(this.toHide=this.toHide.not(this.errorsFor(b)));if(!c)return this.formatAndAdd(b,e),!1}catch(k){throw this.settings.debug&&window.console&&console.log("Exception occurred when checking element "+b.id+", check the '"+e.method+"' method.",k),k instanceof TypeError&&(k.message+=".  Exception occurred when checking element "+b.id+", check the '"+e.method+"' method."),k}}if(!i)return this.objectLength(g)&&this.successList.push(b),!0},customDataMessage:function(b,c){return a(b).data("msg"+c.charAt(0).toUpperCase()+c.substring(1).toLowerCase())||a(b).data("msg")},customMessage:function(a,b){var c=this.settings.messages[a];return c&&(c.constructor===String?c:c[b])},findDefined:function(){for(var a=0;a<arguments.length;a++)if(void 0!==arguments[a])return arguments[a]},defaultMessage:function(b,c){"string"==typeof c&&(c={method:c});var d=this.findDefined(this.customMessage(b.name,c.method),this.customDataMessage(b,c.method),!this.settings.ignoreTitle&&b.title||void 0,a.validator.messages[c.method],"<strong>Warning: No message defined for "+b.name+"</strong>"),e=/\$?\{(\d+)\}/g;return"function"==typeof d?d=d.call(this,c.parameters,b):e.test(d)&&(d=a.validator.format(d.replace(e,"{$1}"),c.parameters)),d},formatAndAdd:function(a,b){var c=this.defaultMessage(a,b);this.errorList.push({message:c,element:a,method:b.method}),this.errorMap[a.name]=c,this.submitted[a.name]=c},addWrapper:function(a){return this.settings.wrapper&&(a=a.add(a.parent(this.settings.wrapper))),a},defaultShowErrors:function(){var a,b,c;for(a=0;this.errorList[a];a++)c=this.errorList[a],this.settings.highlight&&this.settings.highlight.call(this,c.element,this.settings.errorClass,this.settings.validClass),this.showLabel(c.element,c.message);if(this.errorList.length&&(this.toShow=this.toShow.add(this.containers)),this.settings.success)for(a=0;this.successList[a];a++)this.showLabel(this.successList[a]);if(this.settings.unhighlight)for(a=0,b=this.validElements();b[a];a++)this.settings.unhighlight.call(this,b[a],this.settings.errorClass,this.settings.validClass);this.toHide=this.toHide.not(this.toShow),this.hideErrors(),this.addWrapper(this.toShow).show()},validElements:function(){return this.currentElements.not(this.invalidElements())},invalidElements:function(){return a(this.errorList).map(function(){return this.element})},showLabel:function(b,c){var d,e,f,g,h=this.errorsFor(b),i=this.idOrName(b),j=a(b).attr("aria-describedby");h.length?(h.removeClass(this.settings.validClass).addClass(this.settings.errorClass),h.html(c)):(h=a("<"+this.settings.errorElement+">").attr("id",i+"-error").addClass(this.settings.errorClass).html(c||""),d=h,this.settings.wrapper&&(d=h.hide().show().wrap("<"+this.settings.wrapper+"/>").parent()),this.labelContainer.length?this.labelContainer.append(d):this.settings.errorPlacement?this.settings.errorPlacement.call(this,d,a(b)):d.insertAfter(b),h.is("label")?h.attr("for",i):0===h.parents("label[for='"+this.escapeCssMeta(i)+"']").length&&(f=h.attr("id"),j?j.match(new RegExp("\\b"+this.escapeCssMeta(f)+"\\b"))||(j+=" "+f):j=f,a(b).attr("aria-describedby",j),e=this.groups[b.name],e&&(g=this,a.each(g.groups,function(b,c){c===e&&a("[name='"+g.escapeCssMeta(b)+"']",g.currentForm).attr("aria-describedby",h.attr("id"))})))),!c&&this.settings.success&&(h.text(""),"string"==typeof this.settings.success?h.addClass(this.settings.success):this.settings.success(h,b)),this.toShow=this.toShow.add(h)},errorsFor:function(b){var c=this.escapeCssMeta(this.idOrName(b)),d=a(b).attr("aria-describedby"),e="label[for='"+c+"'], label[for='"+c+"'] *";return d&&(e=e+", #"+this.escapeCssMeta(d).replace(/\s+/g,", #")),this.errors().filter(e)},escapeCssMeta:function(a){return a.replace(/([\\!"#$%&'()*+,.\/:;<=>?@\[\]^`{|}~])/g,"\\$1")},idOrName:function(a){return this.groups[a.name]||(this.checkable(a)?a.name:a.id||a.name)},validationTargetFor:function(b){return this.checkable(b)&&(b=this.findByName(b.name)),a(b).not(this.settings.ignore)[0]},checkable:function(a){return/radio|checkbox/i.test(a.type)},findByName:function(b){return a(this.currentForm).find("[name='"+this.escapeCssMeta(b)+"']")},getLength:function(b,c){switch(c.nodeName.toLowerCase()){case"select":return a("option:selected",c).length;case"input":if(this.checkable(c))return this.findByName(c.name).filter(":checked").length}return b.length},depend:function(a,b){return!this.dependTypes[typeof a]||this.dependTypes[typeof a](a,b)},dependTypes:{"boolean":function(a){return a},string:function(b,c){return!!a(b,c.form).length},"function":function(a,b){return a(b)}},optional:function(b){var c=this.elementValue(b);return!a.validator.methods.required.call(this,c,b)&&"dependency-mismatch"},startRequest:function(b){this.pending[b.name]||(this.pendingRequest++,a(b).addClass(this.settings.pendingClass),this.pending[b.name]=!0)},stopRequest:function(b,c){this.pendingRequest--,this.pendingRequest<0&&(this.pendingRequest=0),delete this.pending[b.name],a(b).removeClass(this.settings.pendingClass),c&&0===this.pendingRequest&&this.formSubmitted&&this.form()?(a(this.currentForm).submit(),this.submitButton&&a("input:hidden[name='"+this.submitButton.name+"']",this.currentForm).remove(),this.formSubmitted=!1):!c&&0===this.pendingRequest&&this.formSubmitted&&(a(this.currentForm).triggerHandler("invalid-form",[this]),this.formSubmitted=!1)},previousValue:function(b,c){return c="string"==typeof c&&c||"remote",a.data(b,"previousValue")||a.data(b,"previousValue",{old:null,valid:!0,message:this.defaultMessage(b,{method:c})})},destroy:function(){this.resetForm(),a(this.currentForm).off(".validate").removeData("validator").find(".validate-equalTo-blur").off(".validate-equalTo").removeClass("validate-equalTo-blur")}},classRuleSettings:{required:{required:!0},email:{email:!0},url:{url:!0},date:{date:!0},dateISO:{dateISO:!0},number:{number:!0},digits:{digits:!0},creditcard:{creditcard:!0}},addClassRules:function(b,c){b.constructor===String?this.classRuleSettings[b]=c:a.extend(this.classRuleSettings,b)},classRules:function(b){var c={},d=a(b).attr("class");return d&&a.each(d.split(" "),function(){this in a.validator.classRuleSettings&&a.extend(c,a.validator.classRuleSettings[this])}),c},normalizeAttributeRule:function(a,b,c,d){/min|max|step/.test(c)&&(null===b||/number|range|text/.test(b))&&(d=Number(d),isNaN(d)&&(d=void 0)),d||0===d?a[c]=d:b===c&&"range"!==b&&(a[c]=!0)},attributeRules:function(b){var c,d,e={},f=a(b),g=b.getAttribute("type");for(c in a.validator.methods)"required"===c?(d=b.getAttribute(c),""===d&&(d=!0),d=!!d):d=f.attr(c),this.normalizeAttributeRule(e,g,c,d);return e.maxlength&&/-1|2147483647|524288/.test(e.maxlength)&&delete e.maxlength,e},dataRules:function(b){var c,d,e={},f=a(b),g=b.getAttribute("type");for(c in a.validator.methods)d=f.data("rule"+c.charAt(0).toUpperCase()+c.substring(1).toLowerCase()),this.normalizeAttributeRule(e,g,c,d);return e},staticRules:function(b){var c={},d=a.data(b.form,"validator");return d.settings.rules&&(c=a.validator.normalizeRule(d.settings.rules[b.name])||{}),c},normalizeRules:function(b,c){return a.each(b,function(d,e){if(e===!1)return void delete b[d];if(e.param||e.depends){var f=!0;switch(typeof e.depends){case"string":f=!!a(e.depends,c.form).length;break;case"function":f=e.depends.call(c,c)}f?b[d]=void 0===e.param||e.param:(a.data(c.form,"validator").resetElements(a(c)),delete b[d])}}),a.each(b,function(d,e){b[d]=a.isFunction(e)&&"normalizer"!==d?e(c):e}),a.each(["minlength","maxlength"],function(){b[this]&&(b[this]=Number(b[this]))}),a.each(["rangelength","range"],function(){var c;b[this]&&(a.isArray(b[this])?b[this]=[Number(b[this][0]),Number(b[this][1])]:"string"==typeof b[this]&&(c=b[this].replace(/[\[\]]/g,"").split(/[\s,]+/),b[this]=[Number(c[0]),Number(c[1])]))}),a.validator.autoCreateRanges&&(null!=b.min&&null!=b.max&&(b.range=[b.min,b.max],delete b.min,delete b.max),null!=b.minlength&&null!=b.maxlength&&(b.rangelength=[b.minlength,b.maxlength],delete b.minlength,delete b.maxlength)),b},normalizeRule:function(b){if("string"==typeof b){var c={};a.each(b.split(/\s/),function(){c[this]=!0}),b=c}return b},addMethod:function(b,c,d){a.validator.methods[b]=c,a.validator.messages[b]=void 0!==d?d:a.validator.messages[b],c.length<3&&a.validator.addClassRules(b,a.validator.normalizeRule(b))},methods:{required:function(b,c,d){if(!this.depend(d,c))return"dependency-mismatch";if("select"===c.nodeName.toLowerCase()){var e=a(c).val();return e&&e.length>0}return this.checkable(c)?this.getLength(b,c)>0:b.length>0},email:function(a,b){return this.optional(b)||/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(a)},url:function(a,b){return this.optional(b)||/^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})).?)(?::\d{2,5})?(?:[\/?#]\S*)?$/i.test(a)},date:function(a,b){return this.optional(b)||!/Invalid|NaN/.test(new Date(a).toString())},dateISO:function(a,b){return this.optional(b)||/^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/.test(a)},number:function(a,b){return this.optional(b)||/^(?:-?\d+|-?\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/.test(a)},digits:function(a,b){return this.optional(b)||/^\d+$/.test(a)},minlength:function(b,c,d){var e=a.isArray(b)?b.length:this.getLength(b,c);return this.optional(c)||e>=d},maxlength:function(b,c,d){var e=a.isArray(b)?b.length:this.getLength(b,c);return this.optional(c)||e<=d},rangelength:function(b,c,d){var e=a.isArray(b)?b.length:this.getLength(b,c);return this.optional(c)||e>=d[0]&&e<=d[1]},min:function(a,b,c){return this.optional(b)||a>=c},max:function(a,b,c){return this.optional(b)||a<=c},range:function(a,b,c){return this.optional(b)||a>=c[0]&&a<=c[1]},step:function(b,c,d){var e,f=a(c).attr("type"),g="Step attribute on input type "+f+" is not supported.",h=["text","number","range"],i=new RegExp("\\b"+f+"\\b"),j=f&&!i.test(h.join()),k=function(a){var b=(""+a).match(/(?:\.(\d+))?$/);return b&&b[1]?b[1].length:0},l=function(a){return Math.round(a*Math.pow(10,e))},m=!0;if(j)throw new Error(g);return e=k(d),(k(b)>e||l(b)%l(d)!==0)&&(m=!1),this.optional(c)||m},equalTo:function(b,c,d){var e=a(d);return this.settings.onfocusout&&e.not(".validate-equalTo-blur").length&&e.addClass("validate-equalTo-blur").on("blur.validate-equalTo",function(){a(c).valid()}),b===e.val()},remote:function(b,c,d,e){if(this.optional(c))return"dependency-mismatch";e="string"==typeof e&&e||"remote";var f,g,h,i=this.previousValue(c,e);return this.settings.messages[c.name]||(this.settings.messages[c.name]={}),i.originalMessage=i.originalMessage||this.settings.messages[c.name][e],this.settings.messages[c.name][e]=i.message,d="string"==typeof d&&{url:d}||d,h=a.param(a.extend({data:b},d.data)),i.old===h?i.valid:(i.old=h,f=this,this.startRequest(c),g={},g[c.name]=b,a.ajax(a.extend(!0,{mode:"abort",port:"validate"+c.name,dataType:"json",data:g,context:f.currentForm,success:function(a){var d,g,h,j=a===!0||"true"===a;f.settings.messages[c.name][e]=i.originalMessage,j?(h=f.formSubmitted,f.resetInternals(),f.toHide=f.errorsFor(c),f.formSubmitted=h,f.successList.push(c),f.invalid[c.name]=!1,f.showErrors()):(d={},g=a||f.defaultMessage(c,{method:e,parameters:b}),d[c.name]=i.message=g,f.invalid[c.name]=!0,f.showErrors(d)),i.valid=j,f.stopRequest(c,j)}},d)),"pending")}}});var b,c={};return a.ajaxPrefilter?a.ajaxPrefilter(function(a,b,d){var e=a.port;"abort"===a.mode&&(c[e]&&c[e].abort(),c[e]=d)}):(b=a.ajax,a.ajax=function(d){var e=("mode"in d?d:a.ajaxSettings).mode,f=("port"in d?d:a.ajaxSettings).port;return"abort"===e?(c[f]&&c[f].abort(),c[f]=b.apply(this,arguments),c[f]):b.apply(this,arguments)}),a});

site = {
  initProdSlider: function(){
    $('.js-slickSlideProdImages').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        dots: false,
        lazyLoad: 'ondemand',
        asNavFor: '.js-slickSlideProdThumbs',
        responsive: [
          {
            breakpoint: 1025,
            settings: {
              dots: false,
              arrows: true,
              nextArrow: '<button type="button" class="slick-arrow slick-next btn pdp-mobile-thumb-next"><img src="https://cdn.shopify.com/s/files/1/0443/7144/3879/files/arrow-next-dark.svg?v=1600898398" class="pdp-slick-arrow" alt="Slider Next Arrow"><span class="visually-hidden">Next</span></button>',
              prevArrow: '<button type="button" class="slick-arrow slick-prev btn pdp-mobile-thumb-prev"><img src="https://cdn.shopify.com/s/files/1/0443/7144/3879/files/arrow-prev-dark.svg?v=1600898404" class="pdp-slick-arrow" alt="Slider Previous Arrow"><span class="visually-hidden">Previous</span></button>'
            }
          }
        ]
    });

    $('.js-slickSlideProdThumbs').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.js-slickSlideProdImages',
        focusOnSelect: true,
        mobileFirst: false,
        vertical: true,
        nextArrow: '<button type="button" class="slick-arrow slick-next btn"><img src="https://cdn.shopify.com/s/files/1/0443/7144/3879/files/icon-galleryarrow-down.svg?v=1599146668" class="pdp-slick-arrow" alt="Slider Next Arrow"><span class="visually-hidden">Next</span></button>',
        prevArrow: '<button type="button" class="slick-arrow slick-prev btn"><img src="https://cdn.shopify.com/s/files/1/0443/7144/3879/files/icon-galleryarrow-up.svg?v=1599146674" class="pdp-slick-arrow" alt="Slider Previous Arrow"><span class="visually-hidden">Previous</span></button>'
    });
  },
  run: function() {
    site.initProdSlider();
  }
};

$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = 'body table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  jQuery(function() {
    jQuery(".swatch :radio").change(function() {
      var optionIndex = jQuery(this)
        .closest(".swatch")
        .attr("data-option-index");
      var optionValue = jQuery(this).val();
      jQuery(this)
        .closest("form")
        .find(".single-option-selector")
        .eq(optionIndex)
        .val(optionValue)
        .trigger("change");
      var swatchName = jQuery(this)
        .parent()
        .parent()
        .find(".js-selectedOption")
        .attr("id");
      jQuery("#" + swatchName + ".js-selectedOption").html(optionValue);
    });
    jQuery('.swatch label').keydown(function (e) {
        if (e.keyCode == 13) {
            console.log('here');
            var labelID = $(this).attr('for');
            $('#'+labelID).trigger('click');
        }
    });

    site.run();
  });
  var $selectNav = $(".js-selectNav");

  $('<select id="accountNav" class="hide js-page-nav-select"  />').appendTo($selectNav);

  $($selectNav).find("a").each(function () {
    var $item = $(this);
    var $selected;
    if (window.location.href.indexOf($item.attr("href")) > -1) {
      $selected = true;
    } else {
      $selected = false
    };
    $("<option />", {
      "value": $item.attr("href"),
      "text": $item.text(),
      "selected": $selected
    }).appendTo(".js-page-nav-select");

  });
  $selectNav.on("change", function () {
    var $selectedNav = $(".js-page-nav-select option:selected");

    if ($selectedNav !== '') {
      window.location.href = $selectedNav.val();
    }
  });
  $(".account-container form").validate({
    rules: {
      "customer[firstname]": {
        required: true
      },

      "customer[email]": {
        required: true,
        email: true
      },
      "customer[password]": {
        required: true
      }
    },
    messages: {
      "customer[firstname]": {
        required: "Please enter your first name"
      },
      "customer[email]": {
        required: "Please enter your email address",
        email: "Please enter a valid email address"
      },
      "customer[password]": {
        required: "Please enter a password"
      }
    }
  });
  $('#RecoverPasswordForm form').validate({
    rules: {
      "email": {
        required:true,
        email: true
      }
    },
    messages: {
      "email": {
        required:"Please enter your email address",
        email: "Please enter a valid email address"
      }
    }
  });

  //Product Sorting on collection page
  Shopify.queryParams = {};
if (location.search.length) {
  for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
    aKeyValue = aCouples[i].split('=');
    if (aKeyValue.length > 1) {
      Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
    }
  }
}
jQuery('#sort-by')
  .val('{{ collection.sort_by | default: collection.default_sort_by | escape }}')
  .bind('change', function() {
    Shopify.queryParams.sort_by = jQuery(this).val();
    location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
    //console.log(Shopify.queryParams.sort_by);

  });

  var sValue = Shopify.queryParams.sort_by;
  //console.log(sValue);
  if (sValue === undefined ){
    jQuery('#sort-by').val('manual');
  }
 else {
  jQuery('#sort-by').val(sValue);
 }




    //Load More Button on collection page
    jQuery('#more').click(function(e){

      e.preventDefault();
      ScrollExecute();
  })

  $('.js-featured-product-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 3,
    infinite: true,
    arrows: false,
    dots: true,
    responsive: [
        {
          breakpoint: 768,
          settings: {
            dots: true,
            slidesToShow: 2
          }
        }
      ]
  });

  $(window).on('load resize orientationchange', function() {
        $('.recommendation-slider').each(function(){
            var $carousel = $(this);
            /* Initializes a slick carousel only on mobile screens */
            // slick on mobile
            if ($(window).width() > 1024) {
                if ($carousel.hasClass('slick-initialized')) {
                    $carousel.slick('unslick');
                }
            }
            else{
                if (!$carousel.hasClass('slick-initialized')) {
                    $carousel.slick({
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        mobileFirst: true,
                        infinite: true,
                        arrows: false,
                        dots: true
                    });
                }
            }
        });
    });

  /* Slick needs no get Reinitialized on window Resize after it was destroyed */
    $(window).on('load resize orientationchange', function() {
        $('.js-blog-feed-articles-main-container').each(function(){
            var $carousel = $(this);
            /* Initializes a slick carousel only on mobile screens */
            // slick on mobile
            if ($(window).width() > 768) {
                if ($carousel.hasClass('slick-initialized')) {
                    $carousel.slick('unslick');
                }
            }
            else{
                if (!$carousel.hasClass('slick-initialized')) {
                    $carousel.slick({
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        mobileFirst: true,
                        infinite: true,
                        arrows: false,
                        dots: true
                    });
                }
            }
        });
    });
});

//Load More Ajax
let triggered = false;

function ScrollExecute() {

  let moreButon = $('#more').last();

  // Get URL from the loadmore button
  let nextUrl = $(moreButon).find('a').attr("href");
    // Trigger shortcircuit to ensure AJAX only fires once
    triggered = true;

    // Make ajax call to next page for load more data
    $.ajax({
      url: nextUrl,
      type: 'GET'
    })
    .done(function(data) {
      // Append data
      $('.collection-grids').append($(data).find('.collection-grids').html());
      $('#more').empty();
      $('#more').append($(data).find('#more').html());
      StampedFn.reloadUGC();
      // On success, reset shortcircuit
      triggered = false
    });
  }



(function($) {
  /*

  ADD ON PRODUCT - ADD TO CART

  */
  // console.log('ADDON PRODUCTS...');

  /*$('.product--addon-products [data-single-option-selector]', '[data-section-id="product-section"]').off('change');*/

  if ( $('.product--addon-products').length < 1 ) { return }

  var productAddonObject = JSON.parse($('[data-addon-product-json]', '.product--addon-products').html());
  var addonEnabled = false;
  var currentVariant;
  var currentAddonPrice = 0;

  var $orginalPrices = $('[data-product-price]');
  var orginalPrice = parseFloat( $orginalPrices.eq(0).text().replace('$','') ).toFixed(2) * 100;


  var addonPriceUpdated = false;

  $('[data-product-price]').after('<span data-addon-product-price></span>');

  $('.product-buybox-container .product-price-container [data-addon-product-price]').addClass('product-regular-price');


  $('#addon-checkbox-toggle').on('change', function(e) {

    if ( $(this).is(':checked') ) {
      $('.product-addon--option').addClass('is-active');
      addonEnabled = true;
      $('.product--addon-products .addon-swatch').each(function(i, el){
        $(el).find('.swatch-element label').first().trigger('click');
        $(el).find('.swatch-element input[type="radio"]').first().trigger('change');
      });

     var slect_add_val = $('.product--addon-products .addon-swatch').find('.swatch-element input[type="radio"]:checked').val();
      
      // .product--addon-products [data-addon-option-selector]
      // $('.product--addon-products input[type="radio"]').trigger('change');

    } else {
      
      $('.product-addon--option').removeClass('is-active');
      addonEnabled = false;

      $('[data-addon-product-price]').hide();
      $('[data-product-price]').show();



      $('[data-price-wrapper]').removeClass('price-unavailable');
      $('.afterpay-paragraph').removeClass('afterpay-unavailable');

      $('[data-add-to-cart]').prop('disabled', false);
      $('[data-add-to-cart-text]').html(theme.strings.addToCart);

    }

    // Single Variant
    if ($('#addonProductSelect').length) {
      currentVariant = productAddonObject.variants[0].price;
      addonUpdatePrices( productAddonObject.variants[0] );
    }

    if ($('[data-single-option-selector]').length){
      $('[data-single-option-selector]').trigger('change');
    } else{
      $('[data-product-select]').trigger('change');
    }

  });

  $('[data-single-option-selector],[data-product-select]').on('change', function(e) {
    // console.log('MAIN PRDUCT OPTIONS CHANGE');

    var selectedAddon = addonGetVariantFromOptions();

    if (selectedAddon != null) {
      currentVariant = selectedAddon.price;
      currentAddonPrice = selectedAddon.price;
      $('#addonVariantOption').val( selectedAddon.id );

      
      addonUpdatePrices( selectedAddon );
      currentAddonPrice = selectedAddon.price;
      currentVariant = selectedAddon.price;


      $('[data-price-wrapper]').removeClass('price-unavailable');
      $('.afterpay-paragraph').removeClass('afterpay-unavailable');

      $('[data-add-to-cart]').prop('disabled', false);
      $('[data-add-to-cart-text]').html(theme.strings.addToCart);


      // $('[data-single-option-selector]').trigger('change');

    } else {
        $('[data-add-to-cart]').prop('disabled', true);
        $('[data-add-to-cart-text]').html(theme.strings.unavailable);
        $('[data-price-wrapper]').addClass('price-unavailable');
        $('.afterpay-paragraph').addClass('afterpay-unavailable');
    }


  });


  $('[data-product-price]').on('DOMSubtreeModified', function() {
    // console.log('MAIN PRDUCT PRICE CHANGE');

    var $prices = $('[data-addon-product-price]');
    var currentVariant = addonGetVariantFromOptions();
    if (currentVariant !== null ) {
      console.log('currentVariant: ' + currentVariant);

    var currentPrice = parseFloat( $orginalPrices.eq(0).text().replace('$','') ).toFixed(2) * 100;
    var combindedPrice = currentPrice + currentVariant.price;

    $prices.html(slate.Currency.formatMoney(combindedPrice, theme.moneyFormat));
  }


    if (addonEnabled) {
      $prices.show();
      $('[data-product-price]').hide();
      // $prices.html(slate.Currency.formatMoney(combindedPrice, theme.moneyFormat));
    } else {
      // $prices.html(slate.Currency.formatMoney(orginalPrice, theme.moneyFormat));
      $prices.hide();
      $('[data-product-price]').show();
    }

  });


  $('.product--addon-products [type="radio"]').on('change', function(e) {
    var $selectParent = $(this).parents('[data-addon-option-index]');
    var selectParentIndex = $selectParent.attr('data-addon-option-index');
    $('#AddonOptionSelector-' + selectParentIndex).trigger('change', [$(this).val()]);
  });


  $('.product--addon-products [data-addon-option-selector]').on('change', function(e, selectedOption) {
    if (selectedOption != undefined) {
      $(this).val(selectedOption);
    }

    var selectedAddon = addonGetVariantFromOptions();

    // SHOW/HIDE OPTIONS
    addonToggleVariantFromOptions();

    if (selectedAddon != null) {

      currentVariant = selectedAddon.price;
      currentAddonPrice = selectedAddon.price;
      $('#addonVariantOption').val( selectedAddon.id );

      addonUpdatePrices( selectedAddon );
      currentAddonPrice = selectedAddon.price;
      currentVariant = selectedAddon.price;


      $('[data-price-wrapper]').removeClass('price-unavailable');
      $('.afterpay-paragraph').removeClass('afterpay-unavailable');

      $('[data-add-to-cart]').prop('disabled', false);
      $('[data-add-to-cart-text]').html(theme.strings.addToCart);


      $('[data-single-option-selector]').trigger('change');

    } else {
        $('[data-add-to-cart]').prop('disabled', true);
        $('[data-add-to-cart-text]').html(theme.strings.unavailable);
        $('[data-price-wrapper]').addClass('price-unavailable');
        $('.afterpay-paragraph').addClass('afterpay-unavailable');
    }


  });



  // function addonUpdatePrices(price) {
  function addonUpdatePrices(variant) {
    if (variant.price === currentVariant.price && variant.compare_at_price === currentVariant.compare_at_price) {
      return;
    }

    var $prices = $('[data-addon-product-price]');
    var currentPrice = parseFloat( $orginalPrices.eq(0).text().replace('$','') ).toFixed(2) * 100;
    var combindedPrice = currentPrice + variant.price;

    if (addonEnabled) {
      $prices.show();
      $('[data-product-price]').hide();
      $prices.html(slate.Currency.formatMoney(combindedPrice, theme.moneyFormat));
    } else {
      // $prices.html(slate.Currency.formatMoney(orginalPrice, theme.moneyFormat));
      $prices.hide();
      $('[data-product-price]').show();
    }
  }



  function addonGetVariantFromOptions() {
      var selectedValues = addonGetCurrentOptions();
      var variants = productAddonObject.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    }

  function addonToggleVariantFromOptions() {

    // SHOW/HIDE OPTIONS
    // console.log('OPTIONS SHOW/HIDE');


    var selectedValues = addonGetCurrentOptions();
    var variants = productAddonObject.variants;
    var found = false;

    // console.log( selectedValues );
    var isBeanie = false;

    variants.forEach(function(variant) {
      var satisfied = true;

      selectedValues.forEach(function(option) {
        var $optionSwatch = $('[data-addon-value="' + option.value.replace(/[\""]/g, '\\"') + '"]');

        if (satisfied) {
          satisfied = (option.value === variant[option.index]);
        }
        
        if (option.value == 'Adjustable Headband') {
          $('[data-addon-value="One Size"]').show();
          $('[data-addon-value="One Size"]').siblings('.swatch-element').hide();
          $('[data-addon-value="One Size"]').find('input[type="radio"], label').eq(0).trigger('click');
        }

        if (option.value == 'Beanie' || option.value == 'Beanie with Bow'|| option.value == 'Top-Knot Beanie') {
          isBeanie = true;
        }
      });

      if ( isBeanie == true && $('[data-addon-value="One Size"]').find('input[type="radio"]').is(':checked') ) {
        $('[data-addon-value="One Size"]').siblings('.swatch-element').find('input[type="radio"], label').eq(0).trigger('click');
        $('[data-addon-value="One Size"]').hide().siblings('.swatch-element').show();
      }

      if (satisfied) {
        found = variant;
      }
    });
    // return found || null;
  }

  function addonGetCurrentOptions() {
      var currentOptions = $.map($('.product--addon-products [data-addon-option-selector]'), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('addon-index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('addon-index');

          return currentOption;
        }
      });

      // remove any uncheckeqd input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    }


    /*
      ADD TO CART SUBMIT
    */
    $('form[action="/cart/add"]').on('submit', function(e) {
      e.preventDefault();
      var formData = $(this).find('input, select').not('[data-single-option-selector], [data-addon-option-selector]');
      var data = {};
      var productData = {};
      var addonData = {};
      var optionsProperties = {};

      $(formData).each(function(index, obj){
          if ( obj.name != '' && obj.value != '' ) {

            if (obj.name.indexOf('properties[') >= 0) {
              var propertyName = obj.name.replace(']','').split('properties[')[1];
              optionsProperties[propertyName] = obj.value;
            }

            if( obj.name == 'id' ) {
              productData[obj.name] = obj.value;
            }

            if( obj.name == 'addon-id' ) {
              addonData['id'] = obj.value;
            }

            if( obj.name == 'quantity' ) {
              addonData[obj.name] = obj.value;
              productData[obj.name] = obj.value;
            }

            data[obj.name] = obj.value;
          }
      });


      if (addonEnabled) {
        var itemsData = [
            {
              quantity: productData.quantity,
              id: productData.id,
              properties: optionsProperties
            }
            ,{
              quantity: addonData.quantity,
              id: addonData.id,
              properties: optionsProperties	
            }
          ];
      } else {
        var itemsData = [
            {
              quantity: productData.quantity,
              id: productData.id,
              properties: optionsProperties
            }
          ];
      }


      jQuery.ajax({
        url:'/cart/add.js',
        contentType: 'application/json',
        data: {
          items: itemsData
        }
      }).done(function() {
        // console.log('success!');
        window.location = '/cart';
      });
    });

})(jQuery);


$(document).ready(function () {
  $('input#addon-checkbox-toggle:checked').closest('.product--addon-products').find('.product-addon--option').addClass('is-active');
});